export default __webpack_public_path__ + "static/media/styli.2cde7e29.png";